import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { AppState } from '../+store/app.states';
import { getAuthState } from '../+store/auth/auth.selectors';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  token: string;
  constructor(private store: Store<AppState>) {
    this.store
      .pipe(select(getAuthState))
      .subscribe(state => (this.token = state.token));
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (this.token) {
      const cloned = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + this.token)
      });

      return next.handle(cloned);
    } else {
      return next.handle(req);
    }
  }
}
